import { render, staticRenderFns } from "./StudentInvitationsDialog.vue?vue&type=template&id=bbec43c6&scoped=true"
import script from "./StudentInvitationsDialog.vue?vue&type=script&lang=js"
export * from "./StudentInvitationsDialog.vue?vue&type=script&lang=js"
import style0 from "./StudentInvitationsDialog.vue?vue&type=style&index=0&id=bbec43c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbec43c6",
  null
  
)

export default component.exports